import { render, staticRenderFns } from "./GuessLike.vue?vue&type=template&id=4af453f0&"
import script from "./GuessLike.vue?vue&type=script&lang=js&"
export * from "./GuessLike.vue?vue&type=script&lang=js&"
import style0 from "./GuessLike.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports